function add(first, second) {
	return first + second;
}

var _ref = {},
    hasOwnProperty = _ref.hasOwnProperty;

function hasOwn(prop, obj) {
	return hasOwnProperty.call(obj, prop);
}

function assign() {
	// eslint-disable-next-line no-func-assign
	assign = Object.assign || function (target) {
		for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			sources[_key - 1] = arguments[_key];
		}

		sources.forEach(function (source) {
			for (var key in source) {
				if (hasOwn(key, source)) {
					target[key] = source[key];
				}
			}
		});
		return target;
	};
	return assign.apply(undefined, arguments);
}

function flatMap(iteratee, arr) {
	var _ref;

	return (_ref = []).concat.apply(_ref, arr.map(iteratee));
}

function chain(fn, listOrFn) {
	if (typeof listOrFn === 'function') {
		return function (list) {
			return fn(listOrFn(list))(list);
		};
	}

	return flatMap(fn, listOrFn);
}

var isArray = Array.isArray;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function isObject(obj) {
	return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && !isArray(obj);
}

function mapValues(mapper, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		acc[key] = mapper(obj[key]);
		return acc;
	}, {});
}

function cloneDeep(value) {
	if (isArray(value)) {
		return value.map(cloneDeep);
	}

	if (isObject(value)) {
		return mapValues(cloneDeep, value);
	}

	return value;
}

// slightly simplified version of https://github.com/sindresorhus/camelcase/blob/a526ef0399f9a1310eaacafa0ae4a69da4a2f1ad/index.js
// TODO: possibly could be rewritten using short-ish regexp

var preserveCamelCase = function preserveCamelCase(input) {
	var text = input;
	var isLastCharLower = false;
	var isLastCharUpper = false;
	var isLastLastCharUpper = false;

	for (var index = 0; index < text.length; index++) {
		var char = text[index];

		if (isLastCharLower && /[a-zA-Z]/.test(char) && char.toUpperCase() === char) {
			text = text.slice(0, index) + '-' + text.slice(index);
			isLastCharLower = false;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = true;
			index++;
		} else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(char) && char.toLowerCase() === char) {
			text = text.slice(0, index - 1) + '-' + text.slice(index - 1);
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = false;
			isLastCharLower = true;
		} else {
			isLastCharLower = char.toLowerCase() === char;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = char.toUpperCase() === char;
		}
	}

	return text;
};

function camelCase(input) {
	var text = input.trim();

	if (text.length === 0) {
		return '';
	}

	if (text.length === 1) {
		return text.toLowerCase();
	}

	if (/^[a-z\d]+$/.test(text)) {
		return text;
	}

	var hasUpperCase = text !== text.toLowerCase();

	if (hasUpperCase) {
		text = preserveCamelCase(text);
	}

	text = text.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (match, p1) {
		return p1.toUpperCase();
	});

	return text;
}

function compact(collection) {
	return isArray(collection) ? collection.filter(function (value) {
		return value !== null && value !== undefined;
	}) : Object.keys(collection).reduce(function (result, key) {
		var value = collection[key];
		if (value !== null && value !== undefined) {
			result[key] = value;
		}
		return result;
	}, {});
}

function compose() {
	for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
		funcs[_key] = arguments[_key];
	}

	return funcs.reduce(function (composed, next) {
		return function () {
			return composed(next.apply(undefined, arguments));
		};
	});
}

function debounce(ms, fn) {
	var timeoutId = void 0;

	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		clearTimeout(timeoutId);
		timeoutId = setTimeout.apply(undefined, [fn, ms].concat(args));
	};
}

function isNil(value) {
	return value === null || value === undefined;
}

function defaultTo(defaultValue) {
	return function (value) {
		return isNil(value) ? defaultValue : value;
	};
}

function drop(count, arr) {
	return arr.slice(count);
}

function dropRight(count, arr) {
	return arr.slice(0, -count);
}

function ensureArray(maybeArr) {
	return isArray(maybeArr) ? maybeArr : [maybeArr];
}

// eslint-disable-next-line consistent-return
function find(predicate, arr) {
	for (var index = 0; index < arr.length; index++) {
		var element = arr[index];
		if (predicate(element)) {
			return element;
		}
	}
}

function findIndex(predicate, arr) {
	for (var index = 0; index < arr.length; index++) {
		if (predicate(arr[index])) {
			return index;
		}
	}

	return -1;
}

// eslint-disable-next-line consistent-return
function findKey(predicate, obj) {
	return find(function (key) {
		return predicate(obj[key]);
	}, Object.keys(obj));
}

// eslint-disable-next-line consistent-return
function findLast(predicate, arr) {
	for (var index = arr.length - 1; index >= 0; index--) {
		if (predicate(arr[index])) {
			return arr[index];
		}
	}
}

function findLastIndexFrom(predicate, startIndex, arr) {
	for (var index = startIndex; index >= 0; index--) {
		if (predicate(arr[index])) {
			return index;
		}
	}

	return -1;
}

function findLastIndex(predicate, arr) {
	return findLastIndexFrom(predicate, arr.length - 1, arr);
}

// eslint-disable-next-line lodash-fp/prefer-identity
function identity(value) {
	return value;
}

function flatten(arr) {
	return flatMap(identity, arr);
}

function forOwn(callback, obj) {
	return Object.keys(obj).forEach(function (key) {
		callback(obj[key], key);
	});
}

function fromPairs(pairs) {
	return pairs.reduce(function (obj, _ref) {
		var key = _ref[0],
		    value = _ref[1];

		obj[key] = value;
		return obj;
	}, {});
}

function generateRandomId() {
	return Math.random().toString(36).substring(2);
}

function generateUniqueId(map) {
	var id = generateRandomId();
	return hasOwn(id, map) ? generateUniqueId(map) : id;
}

// based on https://github.com/developit/dlv/blob/d7ec976d12665f1c25dec2acf955dfc2e8757a9c/index.js
function get$1(propPath, obj) {
	var arrPath = typeof propPath === 'string' ? propPath.split('.') : propPath;
	var pathPartIndex = 0;
	var result = obj;
	while (result && pathPartIndex < arrPath.length) {
		result = result[arrPath[pathPartIndex++]];
	}
	return result;
}

function getOr(defaultValue, prop, obj) {
	var propValue = get$1(prop, obj);
	return propValue !== undefined && propValue !== null ? propValue : defaultValue;
}

function groupBy(mapper, collection) {
	return Object.keys(collection).reduce(function (grouped, key) {
		var element = collection[key];
		var groupKey = mapper(element);
		grouped[groupKey] = grouped[groupKey] || [];
		grouped[groupKey].push(element);
		return grouped;
	}, {});
}

function groupKeys(mapper, obj) {
	return Object.keys(obj).reduce(function (grouped, key) {
		var groupKey = mapper(key);
		grouped[groupKey] = grouped[groupKey] || {};
		grouped[groupKey][key] = obj[key];
		return grouped;
	}, {});
}

function includes(value, arr) {
	return arr.indexOf(value) !== -1;
}

function isEmpty(collection) {
	return (isArray(collection) ? collection : Object.keys(collection)).length === 0;
}

function keyBy(prop, arr) {
	return arr.reduce(function (acc, el) {
		acc[el[prop]] = el;
		return acc;
	}, {});
}

function last(arr) {
	return arr.length > 0 ? arr[arr.length - 1] : null;
}

function mapKeys(mapper, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		acc[mapper(key)] = obj[key];
		return acc;
	}, {});
}

function mapValuesIndexed(iteratee, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		acc[key] = iteratee(obj[key], key);
		return acc;
	}, {});
}

function merge(objA, objB) {
	if (isEmpty(objB)) {
		return objA;
	}

	var result = {};

	forOwn(function (value, key) {
		if (hasOwn(key, objB)) {
			if (isObject(objA[key]) && isObject(objB[key])) {
				result[key] = merge(objA[key], objB[key]);
			} else {
				result[key] = objB[key];
			}
		} else {
			result[key] = objA[key];
		}
	}, objA);

	forOwn(function (value, key) {
		if (!hasOwn(key, result)) {
			result[key] = objB[key];
		}
	}, objB);

	return result;
}

function mergeAll(objs) {
	if (objs.length === 0) {
		return {};
	}

	var first = objs[0],
	    rest = objs.slice(1);

	return rest.reduce(function (merged, obj) {
		return merge(merged, obj);
	}, first);
}

function memoizeWith(keyResolver, func) {
	var cache = {};
	return function () {
		var key = keyResolver.apply(undefined, arguments);

		if (hasOwn(key, cache)) {
			return cache[key];
		}

		var value = func.apply(undefined, arguments);
		cache[key] = value;
		return value;
	};
}

function memoize(func) {
	return memoizeWith(identity, func);
}

function memoizeOne(fn) {
	var called = false;
	var memoized = void 0;
	var cacheKey = void 0;

	return function () {
		if (called && (arguments.length <= 0 ? undefined : arguments[0]) === cacheKey) {
			return memoized;
		}
		called = true;
		cacheKey = arguments.length <= 0 ? undefined : arguments[0];
		memoized = fn.apply(undefined, arguments);
		return memoized;
	};
}

function noop() {}

function values(obj) {
	return Object.keys(obj).map(function (key) {
		return obj[key];
	});
}

function numericSortBy(propOrMapper, collection) {
	var mapper = typeof propOrMapper === 'function' ? propOrMapper : function (element) {
		return get$1(propOrMapper, element);
	};
	return (isArray(collection) ? [].concat(collection) : values(collection)).sort(function (elementA, elementB) {
		return mapper(elementA) - mapper(elementB);
	});
}

function omitByIndexed(predicate, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		if (!predicate(obj[key], key)) {
			acc[key] = obj[key];
		}
		return acc;
	}, {});
}

function omit(keys, obj) {
	return omitByIndexed(function (value, key) {
		return keys.indexOf(key) !== -1;
	}, obj);
}

function omitBy(predicate, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		if (!predicate(obj[key])) {
			acc[key] = obj[key];
		}
		return acc;
	}, {});
}

function once(fn) {
	var called = false;
	var result = void 0;
	return function () {
		if (called) {
			return result;
		}
		called = true;
		return result = fn.apply(undefined, arguments);
	};
}

function over(fns) {
	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return fns.map(function (fn) {
			return fn.apply(undefined, args);
		});
	};
}

function takeLast(count, arr) {
	return arr.slice(-count);
}

function overArgs(fn, transformers) {
	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var transformed = transformers.map(function (transform, index) {
			return transform(args[index]);
		});
		return args.length > transformed.length ? fn.apply(undefined, transformed.concat(takeLast(args.length - transformed.length, args))) : fn.apply(undefined, transformed);
	};
}

function pick(props, obj) {
	return props.reduce(function (acc, prop) {
		acc[prop] = obj[prop];
		return acc;
	}, {});
}

function pickBy(predicate, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		if (predicate(obj[key])) {
			acc[key] = obj[key];
		}
		return acc;
	}, {});
}

function pickByIndexed(predicate, obj) {
	return Object.keys(obj).reduce(function (acc, key) {
		if (predicate(obj[key], key)) {
			acc[key] = obj[key];
		}
		return acc;
	}, {});
}

function pickOwn(props, obj) {
	return props.reduce(function (acc, prop) {
		if (hasOwn(prop, obj)) {
			acc[prop] = obj[prop];
		}
		return acc;
	}, {});
}

function reject(predicate, arr) {
	return arr.filter(function (element) {
		return !predicate(element);
	});
}

function removeAt(index, arr) {
	var copy = [].concat(arr);
	copy.splice(index, 1);
	return copy;
}

// based on https://github.com/lukeed/dset/blob/f8ce2f65d4adae7842492eb519a7e55de9abdf38/src/index.js

function set$1(_keys, val, input) {
	var keys = _keys.split ? _keys.split('.') : _keys;
	var length = keys.length;
	// TODO: we should clone as we go instead of doing a deep copy upfront
	var obj = cloneDeep(input);
	var pointer = obj;
	for (var index = 0; index < length; ++index) {
		var pointerValue = pointer[keys[index]];
		if (index === length - 1) {
			pointer = pointer[keys[index]] = val;
			// eslint-disable-next-line eqeqeq
		} else if (pointerValue == null) {
			pointer = pointer[keys[index]] = {};
		} else {
			pointer = pointer[keys[index]] = pointerValue;
		}
	}
	return obj;
}

// https://github.com/reactjs/react-redux/blob/5d792a283554cff3d2f54fad1be1f79cbcab33fe/src/utils/shallowEqual.js

function is(first, second) {
	if (first === second) {
		return first !== 0 || second !== 0 || 1 / first === 1 / second;
	}
	// eslint-disable-next-line no-self-compare
	return first !== first && second !== second;
}

function shallowEqual(objA, objB) {
	if (is(objA, objB)) return true;

	if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		return false;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) return false;

	for (var index = 0; index < keysA.length; index++) {
		if (!hasOwn(keysA[index], objB) || !is(objA[keysA[index]], objB[keysA[index]])) {
			return false;
		}
	}

	return true;
}

function sliceDiff(slice, obj) {
	var picked = pickByIndexed(function (value, key) {
		return value !== obj[key];
	}, slice);
	return isEmpty(picked) ? null : picked;
}

// TODO: this could be written a lot better
function snakeCase(str) {
	var snakeCased = str.replace(/[A-Z]|([\-_ ]+)/g, function (match) {
		var code = match.charCodeAt(0);
		var upperCased = code > 64 && code < 91;
		return upperCased ? '_' + match.toLowerCase() : '_';
	});
	return snakeCased[0] === '_' ? snakeCased.substr(1) : snakeCased;
}

function splitAt(splitPoint, arr) {
	// TODO first item from the tuple could be replaced by dropRight
	return [arr.slice(0, splitPoint), arr.slice(splitPoint, arr.length)];
}

function splitRightWhenAccum(fn, acc, arr) {
	var result = false;

	for (var index = arr.length; index > 0; index--) {
		var _fn = fn(arr[index - 1], acc);
		// eslint-disable-next-line no-param-reassign


		result = _fn[0];
		acc = _fn[1];


		if (result) {
			return splitAt(index - 1, arr);
		}
	}

	return [[], arr];
}

function spread(fn) {
	return function (args) {
		return fn.apply(undefined, args);
	};
}

function sum(numbers) {
	return numbers.reduce(add, 0);
}

function take(count, arr) {
	return arr.slice(0, count);
}

function takeRightWhileFrom(predicate, startIndex, arr) {
	var endIndex = findLastIndexFrom(function (element) {
		return !predicate(element);
	}, startIndex, arr);
	return endIndex === startIndex ? [] : arr.slice(endIndex + 1, startIndex + 1);
}

function throttle(ms, fn) {
	var lastCall = Date.now() - 2 * ms;
	var trailingId = void 0;

	var invoke = function invoke() {
		lastCall = Date.now();
		fn.apply(undefined, arguments);
	};

	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var now = Date.now();

		if (now - lastCall >= ms) {
			invoke.apply(undefined, args);
			return;
		}

		clearTimeout(trailingId);
		trailingId = setTimeout.apply(undefined, [invoke, lastCall - now + ms].concat(args));
	};
}

function toPairs(obj) {
	return Object.keys(obj).map(function (key) {
		return [key, obj[key]];
	});
}

function trailingThrottle(ms, fn) {
	var lastCall = Date.now() - 2 * ms;
	var trailingId = void 0;

	var invoke = function invoke() {
		lastCall = Date.now();
		return fn.apply(undefined, arguments);
	};

	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var now = Date.now();

		if (now - lastCall >= ms) {
			lastCall = Date.now();
		}

		clearTimeout(trailingId);
		trailingId = setTimeout.apply(undefined, [invoke, lastCall - now + ms].concat(args));
	};
}

var leadingWhiteSpace = /^\s+/;

function trimStart(str) {
	return str.replace(leadingWhiteSpace, '');
}

var trailingWhiteSpace = /\s+$/;

function trimEnd(str) {
	return str.replace(trailingWhiteSpace, '');
}

function uniqBy(iteratee, arr) {
	// with polyfills this could be just: return Array.from(new Set(arr.map(iteratee)))
	var seen = [];
	return arr.filter(function (element) {
		var key = iteratee(element);
		if (seen.indexOf(key) === -1) {
			seen.push(key);
			return true;
		}
		return false;
	});
}

function uniq(arr) {
	return uniqBy(identity, arr);
}

function update(index, newElement, arr) {
	return [].concat(arr.slice(0, index), [newElement], arr.slice(index + 1, arr.length));
}

function without(removed, arr) {
	return arr.filter(function (element) {
		return removed.indexOf(element) === -1;
	});
}

export { add, assign, chain, cloneDeep, camelCase, compact, compose, debounce, defaultTo, drop, dropRight, ensureArray, find, findIndex, findKey, findLast, findLastIndex, findLastIndexFrom, flatMap, flatten, forOwn, fromPairs, generateRandomId, generateUniqueId, get$1 as get, getOr, groupBy, groupKeys, hasOwn, identity, includes, isArray, isEmpty, isNil, isObject, keyBy, last, mapKeys, mapValues, mapValuesIndexed, merge, mergeAll, memoize, memoizeOne, memoizeWith, noop, numericSortBy, omit, omitBy, omitByIndexed, once, over, overArgs, pick, pickBy, pickByIndexed, pickOwn, reject, removeAt, set$1 as set, shallowEqual, sliceDiff, snakeCase, splitAt, splitRightWhenAccum, spread, sum, take, takeLast, takeRightWhileFrom, throttle, toPairs, trailingThrottle, trimStart, trimEnd, uniq, uniqBy, update, values, without };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/data-utils/dist/data-utils.es.js
// module id = 112
// module chunks = 0